import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReportIcon from '@material-ui/icons/Report';
import {
  TextField,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
// @material-ui/icons
import FavoriteIcon from '@material-ui/icons/Favorite';
import Button from 'components/MaterialKit/CustomButtons/Button.js';
import { CheckFormikValues } from '../../../../components/Formik/CheckFormikValues';

import styles from 'assets/jss/material-kit-react/views/loginPage.js';
import { useSelector, shallowEqual } from 'react-redux';

const useStyles = makeStyles(styles);

const labels = {
  0.5: 'Useless',
  1: 'Useless+',
  1.5: 'Poor',
  2: 'Poor+',
  2.5: 'Ok',
  3: 'Ok+',
  3.5: 'Good',
  4: 'Good+',
  4.5: 'Excellent',
  5: 'Excellent+',
};

const StyledRating = withStyles({
  iconFilled: {
    color: '#ff6d75',
  },
  iconHover: {
    color: '#ff3d47',
  },
})(Rating);

const ReportPostForm = (props) => {
  const check = false;

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
  } = props;

  const classes = useStyles();
  const [hover, setHover] = useState(-1);
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <form onSubmit={handleSubmit} className={classes.form}>
        <FormControl
          style={{ padding: '1rem', margin: '0 auto', width: '100%' }}
        >
          <StyledRating
            name='rating'
            value={values.rating}
            precision={0.5}
            onBlur={handleBlur}
            onChange={(e, value) => setFieldValue('rating', Number(value))}
            onChangeActive={(event, newHover) => {
              setHover(newHover);
            }}
            size='large'
            icon={<FavoriteIcon fontSize='large' />}
          />
        </FormControl>

        <div style={{ padding: '1rem' }}>
          <Button fullWidth round type='submit' color='rose' size='lg'>
            Rate Post
          </Button>
        </div>

        {check ? <CheckFormikValues {...props.values} /> : ''}
      </form>
    </div>
  );
};

ReportPostForm.propTypes = {};

export default ReportPostForm;
